<template>
  <v-col class="mx-4 py-0 mt-2">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500; width: 100%"
      >
        COD Payments by
      </div>
      <v-spacer></v-spacer>
      <v-tabs color="primary" v-model="tab" style="width: 290px">
        <v-tab :to="{ name: 'CarrierCod' }">Carrier</v-tab>
        <v-tab :to="{ name: 'RsaCod' }">RSA</v-tab>
      </v-tabs>
    </div>

    <v-divider class="mt-1 mb-4"></v-divider>

    <div>
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </v-col>
</template>
<script>
export default {
  data() {
    return {
      tab: null,
    };
  },
};
</script>
